export const getProjectStepName = (step) => {

    if(!step) {
        console.log('no step passed into getProjectStepName');
        return null
    }

    step = parseInt(step)

    switch (step) {
        case 1: return 'Gathering Information'; 
        case 2: return 'Planning Architecture'; 
        case 3: return 'Developing Codebase'; 
        case 4: return 'Running Tests'; 
        case 5: return 'In Production'; 
            
        default: return null
            
    }

}

export const getProjectStepImg = (step) => {

    if(!step) {
        console.log('no step passed into getProjectStepImg');
        return null
    }

    step = parseInt(step)

    switch (step) {
        case 1: return require('assets/img/misc/ProjectStep1.png'); 
        case 2: return require('assets/img/misc/ProjectStep2.png'); 
        case 3: return require('assets/img/misc/ProjectStep3.png'); 
        case 4: return require('assets/img/misc/ProjectStep4.png'); 
        case 5: return require('assets/img/misc/ProjectStep5.png'); 
            
        default: return null
            
    }

}